var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('v-card-title',{staticClass:"white--text mt-1",staticStyle:{"font-size":"20px"}},[_vm._v("Sistema de Gestión de Polígonos")]),_c('img',{attrs:{"src":_vm.logoZurich,"alt":"Logo Zurich"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }